import React, { useState, useEffect, useRef } from 'react';
import { svg } from '../assets/svg/common.js';
import { convertToLocal } from '../helper/commonHelper.js'
import { updateEmails, deleteEmails } from '../helper/emailHelper.js';
import { useLoading } from '../context/LoadingContext';
import { useDispatch, useSelector } from "react-redux";

function MessageList(props) {
    const [messages, setMessages] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [heightToEnd, setHeightToEnd] = useState(0);
    const { showLoader, hideLoader } = useLoading();
    const isDragable = ["important", "inbox", "sent"].includes(props.pageType);
    const [openChildIndex, setOpenChildIndex] = useState([]);
    const [checkedMessages, setCheckedMessages] = useState([]);
    const dragImageRef = useRef(null);
    const messageRef = useRef(null);
    const dispatch = useDispatch();
    const triggerPaninate = useSelector((state) => state.triggerPaninate);
    const triggerDraft = useSelector((state) => state.triggerDraft);
    const isChecked = useSelector((state) => state.isChecked);

    useEffect(() => {
        setMessages(props.messages);
        if (!props.selectedmessage) {
            setSelectedIndex(null);
        }
    }, [props])

    useEffect(() => {
        if (isChecked) {
            const filteredMessages = messages.flatMap(message => {
                if (message.groupKey) {
                    return message.data.map(item => item.id);
                }
                return message.id;
            });
            dispatch({ type: "SELECTED_MESSAGES", payload: filteredMessages });
            setCheckedMessages(filteredMessages);
        } else {
            dispatch({ type: "SELECTED_MESSAGES", payload: [] });
            setCheckedMessages([]);
        }

    }, [isChecked])

    useEffect(() => {
        const calculateHeight = () => {
            const messageSection = document.querySelector('.message-section');
            const messageSectionTop = messageSection.getBoundingClientRect().top;
            const heightToEnd = window.innerHeight - messageSectionTop;
            setHeightToEnd(heightToEnd);
        };

        calculateHeight();

        window.addEventListener('resize', calculateHeight);

        return () => {
            window.removeEventListener('resize', calculateHeight);
        };
    }, []);

    useEffect(() => {
        const dragImageElement = document.createElement('div');
        dragImageElement.className = 'drag-image';
        dragImageElement.innerText = 'move this conversation';
        document.body.appendChild(dragImageElement);
        dragImageRef.current = dragImageElement;

        return () => {
            document.body.removeChild(dragImageElement);
        };
    }, []);

    const dragStart = (e, message, type) => {
        const dragImage = dragImageRef.current;
        if (dragImage) {
            e.dataTransfer.setDragImage(dragImage, 0, 0);
            e.dataTransfer.setData('message_id', message.id);
            e.dataTransfer.setData('message_type', type);
        }
    };

    const dragEnd = (e) => {
        document.body.classList.remove('grabbing');
    };

    const favAction = async (id) => {
        showLoader();
        await updateEmails('fav', [id]);
        props.reRender();
        hideLoader();
    }

    const getDisplayName = (message, pageType) => {
        const data = JSON.parse(message.emailDetails);
        const name = message.isSent
            ? `To: ${[data.to, data.cc, data.bcc].filter(Boolean).join(", ").split(',')[0]}`
            : data.sender;

        return pageType !== 'draft' ? name.split('@')[0] : message.sender?.split('@')[0];
    };

    function htmlToPlainText(html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }

    const deleteMessage = async (id) => {
        showLoader();
        await deleteEmails(props.pageType, [id]);
        props.reRender();
        hideLoader();
    }

    const handleScroll = () => {
        const scrollTop = messageRef.current.scrollTop;
        const scrollHeight = messageRef.current.scrollHeight;
        const clientHeight = messageRef.current.clientHeight;
        if (scrollTop + clientHeight >= (scrollHeight)) {
            dispatch({ type: "TRIGGER_PAGINATE", payload: !triggerPaninate });
        }
    };

    useEffect(() => {
        if (!messageRef.current) return;
        const currentMessageRef = messageRef.current;

        currentMessageRef.addEventListener('scroll', handleScroll);

        return () => {
            if (currentMessageRef) {
                currentMessageRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll]);

    const setChildIndex = (index) => {
        openChildIndex.includes(index) ? setOpenChildIndex(openChildIndex.filter(item => item !== index)) : setOpenChildIndex([...openChildIndex, index])
    }

    const handleCheckboxChange = (e, messageId) => {
        e.stopPropagation();
        const updatedCheckedMessages = e.target.checked
            ? [...checkedMessages, messageId]
            : checkedMessages.filter(id => id !== messageId);
        dispatch({ type: "SELECTED_MESSAGES", payload: updatedCheckedMessages });
        setCheckedMessages(updatedCheckedMessages);
    };

    const messageContents = (message, index) => {
        const isSelected = checkedMessages.includes(message.id);
        return (
            <div key={index} className={`message-section-row cursor-pointer border-bottom ${selectedIndex === message.id ? 'active' : ''} ${message.isRead ? 'unread' : ''}`} onClick={(e) => {
                setSelectedIndex(message.id); props.setSelectedMgs(message); if (props.pageType === 'draft') dispatch({ type: "IS_COMPOSE", payload: true, isDraft: message.id }); dispatch({ type: "TRIGGER_DRAFT", payload: !triggerDraft });
            }} draggable={isDragable ? 'true' : 'false'} onDragStart={(e) => dragStart(e, message, props.pageType)} onDragEnd={dragEnd}>
                <div className="d-flex pt-3 justify-content-between align-items-center">
                    <div className="msg-list-header d-flex align-items-center gap-2">
                        <span className="profile-pic cursor-pointer">{getDisplayName(message, props.pageType).startsWith('To:') ? getDisplayName(message, props.pageType).charAt(4).toUpperCase() || '#' : getDisplayName(message, props.pageType).charAt(0).toUpperCase() || '#'}</span>
                        <span className="msg-name text-truncate">{getDisplayName(message, props.pageType)}</span>
                    </div>
                    <div className="msg-time text-truncate">{convertToLocal(message.created_at)}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="msg-subject text-truncate">{message.subject}</div>
                </div>
                <div className="d-flex justify-content-between">

                    <span className="msg-message text-truncate">
                        <span><input type="checkbox" checked={isSelected} onClick={(e) => handleCheckboxChange(e, message.id)} /></span>
                        {props.pageType !== 'draft' ? `0x${message.encryptedData.slice(100, 130)}` : htmlToPlainText(message.encryptedData)}...</span>
                    {props.pageType !== 'draft' ?
                        <span className="msg-fav-icon" onClick={async (e) => {
                            e.stopPropagation();
                            await favAction(message.id);
                        }}>{message.isStarred ? svg.fav : svg.star}</span>
                        : <span onClick={async (e) => {
                            e.stopPropagation();
                            await deleteMessage(message.id);
                        }}>{svg.delete}</span>}
                </div>
            </div>
        );

    }

    return (
        <>
            <div className="col-lg-3 message-section col-md-4 col-sm-6 col-8 pb-3 pt-3 border-end" ref={messageRef} style={{ height: `${heightToEnd}px` }}>
                {messages.map((message, index) => {
                    if (message && message.groupKey) {
                        return (
                            <>
                                <div key={index} className={`message-section-row cursor-pointer border-bottom`} onClick={() => { setChildIndex(index) }}>
                                    <div className="d-flex pt-3 justify-content-between align-items-center">
                                        <div className="msg-list-header d-flex align-items-center gap-2">
                                            <span className="profile-pic cursor-pointer">{message.groupKey.charAt(0).toUpperCase() || '#'}</span>
                                            <span className="msg-name text-truncate">{message.groupKey.split('___')[0].split('@')[0]}</span>
                                        </div>
                                        <div className="msg-time text-truncate">{convertToLocal(message.created_at)}</div>
                                    </div>
                                    <div className="d-flex mt-2">
                                        <span className='ps-2' style={{ rotate: !openChildIndex.includes(index) ? '270deg' : '' }}>{svg.group_down}</span>
                                        <div className="msg-subject text-truncate ps-3">{message.groupKey.split('___')[1]}</div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        {/* <span className="msg-message text-truncate"></span> */}
                                        {/* <span>{svg.delete}</span> */}
                                    </div>
                                </div>
                                {openChildIndex.includes(index) &&
                                    <div className='group-emails'>
                                        {message.data.map((msg, ind) => (
                                            <div key={ind}>{messageContents(msg, ind)}</div>
                                        ))}
                                    </div>
                                }
                            </>
                        );
                    } else {
                        return messageContents(message, index);
                    }
                })}
                <div ref={dragImageRef} style={{ display: 'none' }}>
                    <div className="drag-image">move this conversation</div>
                </div>
                {/* {messages.length > 10 &&
                    <div className='d-flex justify-content-center mt-2'>
                        <button className='new-msg-btn'>New Message</button>
                    </div>
                } */}
            </div>
        </>
    );

}

export default MessageList;
